export default "__VITE_PUBLIC_ASSET__644793c9__"